/**
 * URL presets by APP_ENV. Override any value via REACT_APP_* in .env.
 *
 * Production master API is always under /backend (SPA occupies / on login.apexbrain.in).
 * Calling https://login.apexbrain.in/api/... hits the React app and looks like a CORS error.
 */
const appEnv = process.env.REACT_APP_APP_ENV || "production";

const presets = {
  production: {
    websiteUrl: "https://apexbrain.in",
    apiUrl: "https://login.apexbrain.in/backend",
    statusUrl: "https://status.apexbrain.in",
  },
  development: {
    websiteUrl: "http://localhost:3000",
    apiUrl: "http://localhost:8082",
    statusUrl: "https://status.apexbrain.in",
  },
};

const preset = presets[appEnv] || presets.production;

function stripTrailingSlash(url) {
  return String(url || "").replace(/\/$/, "");
}

function masterApiUrl(url) {
  const trimmed = stripTrailingSlash(url);
  if (/^https:\/\/login\.apexbrain\.in$/i.test(trimmed)) {
    return `${trimmed}/backend`;
  }
  return trimmed;
}

export const APP_ENV = appEnv;
export const WEBSITE_URL = stripTrailingSlash(
  process.env.REACT_APP_WEBSITE_URL || preset.websiteUrl,
);
export const API_URL = masterApiUrl(
  process.env.REACT_APP_API_URL || preset.apiUrl,
);
export const SAAS_API_URL = masterApiUrl(
  process.env.REACT_APP_SAAS_API_URL || API_URL,
);
export const API_PROXY = masterApiUrl(
  process.env.REACT_APP_API_PROXY || API_URL,
);
export const STATUS_SITE_URL = (
  process.env.REACT_APP_STATUS_URL || preset.statusUrl || "https://status.apexbrain.in"
).replace(/\/$/, "");
